// @flow
import { connect } from 'react-redux'
import AgeRange, { type Props } from './AgeRange'
import type { Store } from '../../redux/ducks'
import { patch } from '../AudienceEditContainer'

type OwnProps = {|
  onChange: () => void
|}

function mapStateToProps(state: Store): Object {
  const audienceState = state.audienceEdit
  const initial = audienceState.initial

  if (!initial) return {}

  const properties = initial.ageRange.properties
  const extraProperties = properties
    ? {
        minAgeLimit: properties.minAgeLimit,
        maxAgeLimit: properties.maxAgeLimit
      }
    : {}

  return {
    ...extraProperties,
    errors: audienceState.ageErrors,
    minAge: audienceState.minAge,
    maxAge: audienceState.maxAge
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: OwnProps) {
  return {
    onMinAgeChange: (value: number | null) => {
      patch(dispatch, { minAge: value })
      ownProps.onChange && ownProps.onChange()
    },
    onMaxAgeChange: (value: number | null) => {
      patch(dispatch, { maxAge: value })
      ownProps.onChange && ownProps.onChange()
    }
  }
}

const AgeRangeContainer = connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(AgeRange)

export default AgeRangeContainer
